import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  TrendingUp as TrendingUpIcon
} from '@mui/icons-material';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { useReportsServiceGetApiReportsTasksLastDaysCount } from '../../api/generated/queries/queries';
import WidgetCard from '../DashboardWidgets/WidgetCard';

const TaskGrowthWidget: React.FC = () => {
  const { data: tasksCount, isLoading, error } = useReportsServiceGetApiReportsTasksLastDaysCount();

  if (isLoading) {
    return (
      <WidgetCard>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="120px">
          <CircularProgress size={24} />
        </Box>
      </WidgetCard>
    );
  }

  if (error) {
    return (
      <WidgetCard>
        <Alert severity="error" sx={{ border: 'none', p: 0 }}>
          Błąd podczas ładowania danych raportów.
        </Alert>
      </WidgetCard>
    );
  }

  // Prepare data for the bar chart
  const chartData = [
    { name: '7 dni', value: tasksCount?.last7Days || 0, label: 'Ostatnie 7 dni' },
    { name: '14 dni', value: tasksCount?.last14Days || 0, label: 'Ostatnie 14 dni' },
    { name: '30 dni', value: tasksCount?.last30Days || 0, label: 'Ostatnie 30 dni' }
  ];

  return (
    <WidgetCard>
      {/* Header */}
      <Box
        mb={1.5}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pb={1}
        borderBottom="1px solid"
        borderColor="divider"
      >
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              backgroundColor: '#e3f2fd',
              borderRadius: '50%',
              width: 28,
              height: 28,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mr: 1,
            }}
          >
            <TrendingUpIcon sx={{ color: '#1976d2', fontSize: 18 }} />
          </Box>
          <Typography variant="subtitle1" fontWeight={600} fontSize="0.95rem">
            Przyrost zadań
          </Typography>
        </Box>
      </Box>

      {/* Content - Bar Chart */}
      <Box sx={{ height: 200, mt: 2 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <defs>
              <linearGradient id="taskBarGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#42a5f5" />
                <stop offset="100%" stopColor="#1976d2" />
              </linearGradient>
            </defs>
            <XAxis 
              dataKey="name" 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <YAxis 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#666' }}
            />
            <Bar 
              dataKey="value" 
              fill="url(#taskBarGradient)"
              radius={[4, 4, 0, 0]}
            >
              <LabelList 
                dataKey="value" 
                position="top" 
                style={{ 
                  fontSize: '11px', 
                  fill: '#666', 
                  fontWeight: 500 
                }} 
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </WidgetCard>
  );
};

export default TaskGrowthWidget;